(function(){
  function normalizeColor(val) {
    return String(val || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // quita acentos
      .trim()
      .replace(/\s+/g,'-');
  }

  async function addToCart(variantId){
    try {
    // Agrega el producto
    const res = await fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json','Accept':'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    await res.json(); // solo para asegurarnos que se completó la adición

    // Trae el carrito actualizado
    const cartRes = await fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json','Accept':'application/json' }
    });
    const cartData = await cartRes.json();

    console.log('Producto agregado al carrito', cartData);

    // Dispara el evento con el carrito actualizado
    document.dispatchEvent(new CustomEvent('cart:updated',{ detail:{ cart: cartData }}));

    // Opcional: abrir el mini cart
    const cartTrigger = document.querySelector('.hdt-site-nav_cart a[aria-controls="CartDrawer"]');
    if (cartTrigger) cartTrigger.click();

  } catch(err){
      console.error('Error al agregar:', err);
    }
  }

  function normalizeColorInputs(root) {
    const colorInputs = root.querySelectorAll('.hdt-color-list-item input[type="radio"]');
    colorInputs.forEach(input => {
      input.value = normalizeColor(input.value);
    });
  }

  function applyColorSizeLogic(root) {
    normalizeColorInputs(root);

    const colorInputs = root.querySelectorAll('.hdt-color-list-item input[type="radio"]');
    const sizeButtons = root.querySelectorAll('.hdt-size-list-item');

    if (sizeButtons.length === 0) return;

    // Detecta color activo o selecciona el primero
    let activeColor = root.querySelector('.hdt-color-list-item input[type="radio"]:checked');
    if (!activeColor && colorInputs.length > 0) {
      colorInputs[0].checked = true;
      activeColor = colorInputs[0];
    }

    const selectedColor = activeColor?.value;

    sizeButtons.forEach(btn => {
      const btnColor = normalizeColor(btn.dataset.color);

      if (btnColor === selectedColor) {
        // Mostrar todas las tallas del color seleccionado
        btn.classList.add('visible-size');
        btn.classList.remove('hidden');

        if (btn.disabled) {
          // Aplica estilo de no disponible
          btn.classList.add('unavailable');
          btn.classList.remove('active'); // si estaba activo
        } else {
          // Disponible → puede seleccionarse
          btn.classList.remove('unavailable');
        }

      } else {
        // Oculta las tallas de otros colores
        btn.classList.remove('visible-size');
        btn.classList.add('hidden');
      }
    });
  }

  if (!window.hcOnColorChange) {
    window.hcOnColorChange = function(e){
      if (!e.target.matches('.hdt-color-list-item input[type="radio"]')) return;
      const productRoot = e.target.closest('.hdt-card-product__wrapper') || document;
      applyColorSizeLogic(productRoot);
    };
    document.addEventListener('change', window.hcOnColorChange);
  }

  if (!window.hcOnSizeClick) {
    window.hcOnSizeClick = function(e){
      if (!e.target.matches('.hdt-size-list-item') || !e.target.dataset.variantId) return;
      const productRoot = e.target.closest('.hdt-card-product__wrapper') || document;
      const sizeButtons = productRoot.querySelectorAll('.hdt-size-list-item');
      sizeButtons.forEach(btn => btn.classList.remove('active'));
      e.target.classList.add('active');
      addToCart(e.target.dataset.variantId);
    };
    document.addEventListener('click', window.hcOnSizeClick);
  }

  function initColorAndSizeLogic(root=document){
    const productContainers = root.querySelectorAll('.hdt-card-product__wrapper');
    productContainers.forEach(productRoot => {
      applyColorSizeLogic(productRoot);
    });
  }

  /* Sincroniza con el minicart al momento de eliminar items del minicart */
  async function syncSizesWithCart(root=document) {
  try {
    const cartRes = await fetch('/cart.js');
    const cartData = await cartRes.json();

    const productContainers = root.querySelectorAll('.hdt-card-product__wrapper');
    productContainers.forEach(productRoot => {
      const sizeButtons = productRoot.querySelectorAll('.hdt-size-list-item');
      sizeButtons.forEach(btn => {
        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        // Si la variante está en el carrito → mantener active
        const inCart = cartData.items.some(item => item.id == variantId);
        btn.classList.toggle('active', inCart);
      });
    });
  } catch(err) {
    console.error('Error sincronizando PLP con carrito:', err);
  }
}

  function setupDynamicNavigationSupport() {
    let lastUrl = location.href;

    function onUrlChange() {
      if (location.href !== lastUrl) {
        lastUrl = location.href;
        initColorAndSizeLogic();
      }
    }

    const pushState = history.pushState;
    history.pushState = function() {
      pushState.apply(this, arguments);
      window.dispatchEvent(new Event('locationchange'));
    };
    const replaceState = history.replaceState;
    history.replaceState = function() {
      replaceState.apply(this, arguments);
      window.dispatchEvent(new Event('locationchange'));
    };

    window.addEventListener('popstate', () => {
      window.dispatchEvent(new Event('locationchange'));
    });

    window.addEventListener('locationchange', onUrlChange);

    document.addEventListener('shopify:section:load', () => initColorAndSizeLogic());
    document.addEventListener('page:loaded', () => initColorAndSizeLogic());
    document.addEventListener('turbo:load', () => initColorAndSizeLogic());
  }

  function setupGlobalMutationObserver() {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches && node.matches('.hdt-card-product__wrapper')) {
            applyColorSizeLogic(node);
          } else {
            const nestedProducts = node.querySelectorAll && node.querySelectorAll('.hdt-card-product__wrapper');
            if (nestedProducts && nestedProducts.length) {
              nestedProducts.forEach(np => applyColorSizeLogic(np));
            }
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initColorAndSizeLogic();
    setupDynamicNavigationSupport();
    setupGlobalMutationObserver();

    // Observa cambios en el carrito para sincronizar tallas
  const cartDrawer = document.querySelector('#CartDrawer');
  if (cartDrawer) {
    const cartObserver = new MutationObserver(() => {
      syncSizesWithCart(); // ✅ aquí sí funciona porque está dentro del IIFE
    });
    cartObserver.observe(cartDrawer, { childList: true, subtree: true });
  }
  });

  document.addEventListener('cart:updated', async (e) => {
    try {

      const res = await fetch('/?sections=cart-drawer');
      const data = await res.json();
      const cartDrawer = document.querySelector('#CartDrawer');
      if (cartDrawer && data['cart-drawer']) {
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(data['cart-drawer'], 'text/html');
        const newContent = newDoc.querySelector('#CartDrawer .hdt-dialog-drawer__inner');
        if (newContent) {
          const currentContent = cartDrawer.querySelector('.hdt-dialog-drawer__inner');
          if (currentContent) currentContent.replaceWith(newContent);
        }
        cartDrawer.setAttribute('open', '');
      }
      // Actualiza la cantidad en el contador
      const cartCountBox = document.querySelector('.hdt-count-box');
      if (cartCountBox && e.detail?.cart?.item_count !== undefined) {
        cartCountBox.textContent = e.detail.cart.item_count;
      }

       // ✅ Nueva línea: sincroniza tallas en PLP
      await syncSizesWithCart();

    } catch(err) {
      console.error('Error refrescando minicart con Sections API:', err);
    }
  });

  window.initColorAndSizeLogic = initColorAndSizeLogic;

})();